
import { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import { disenioCarrito } from "../../../data";
import { useCalcularPrecios, separadorMillares } from "../../../hooks";
import { AgregarTerminados } from "../components";
import { SelectSencillo, TextFormField, ViewPreciosPorRol } from "../../components";
import { buscarProducto } from "../../../helpers/FormulariosCarrito";
import { useProductosStore } from "../../../stores";

import Swal from "sweetalert2";



export const FormularioLitografia = ({ formCarrito, setFormCarrito, funcionAgregar, poducto,
                                        titulo='Agregar Producto', carrito, medida=6 }) => {


    const { activarTerminado } = useProductosStore();
    const { calcularPrecioLitografias } = useCalcularPrecios();
    const [ precioReal, setPrecioReal ] = useState(0);
    const [ millares, setMillares ] = useState(0);



    useEffect(() => {
        setMillares((formCarrito.cantidad || 0) * 1000);
    }, [formCarrito.cantidad]);



    useEffect( () => {
        if( poducto ) {
            const { cliente, 
            distri, 
            empresa, 
            publicista, 
            precioReal } = calcularPrecioLitografias( formCarrito.disenio, poducto, formCarrito.cantidad, activarTerminado );
            setPrecioReal( precioReal - cliente );
            setFormCarrito({
                ...formCarrito,
                totalCliente: cliente,
                totalDistri: distri,
                totalEmpresa: empresa,
                totalPublicista: publicista,
            });
        }
    }, [poducto, formCarrito.cantidad, formCarrito.disenio, activarTerminado]);



    const handleInputChange = ({ target }) => {
        setFormCarrito({
            ...formCarrito,
            [target.name]: target.value
        });

        if(target.value === 'Sin Diseño') {
            Swal.fire('Importante', 'Las categorias sin diseño necesitan archivos de optima calidad editable en: pdf, corel o ilustrator, de lo contrario se cobrara el servicio de diseño. ', 'question');
        }
    }


    
    const handleAgregarAlCarro = (e) => {
        e.preventDefault();
        if( formCarrito.cantidad <= 0 ) { return Swal.fire('Error', 'Debes poner una cantidad', 'error') }

        if( formCarrito.disenio === '' ) { return Swal.fire('Error', 'Debes seleccionar con o sin diseño', 'error') }

        const itemID = buscarProducto(carrito, formCarrito.producto);
        funcionAgregar(itemID)
    }




    return (

        <form onSubmit={ handleAgregarAlCarro } style={{ width:'100%' }}>
            <Grid container sx={{mt:0}} spacing={2}>
                <Grid item xs={12} sm={medida}>
                    <TextFormField
                        size="small"
                        label={`Cantidad ${millares === 0 ? '' : `${millares} unidades`}`}
                        type='number'
                        placeholder="1 Equivale a 1000 unidades"
                        name="cantidad"
                        value={formCarrito.cantidad}
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={medida}>
                    <SelectSencillo
                        size="small"
                        label="Diseño"
                        name="disenio"
                        value={formCarrito.disenio}
                        onChange={ handleInputChange } 
                        options={disenioCarrito}
                    />
                </Grid>

                <AgregarTerminados formCarrito={formCarrito} setFormCarrito={setFormCarrito} />
            </Grid>


            {/* Mostrar Precio Segun Rol */}
            <ViewPreciosPorRol formCarrito={formCarrito} />


            <Grid container sx={{ mt:1 }} spacing={2}>
                <Grid item xs={12} sm={(precioReal <= 0) ? 12 : medida}>
                    <Button type="submit" color='primary' variant="contained" fullWidth>{ titulo }</Button>
                </Grid>

                {(precioReal > 0) && (
                <Grid item xs={12} sm={medida}>
                    <Button color='secondary' variant="contained" fullWidth>
                        Ahorra { `$${ separadorMillares( precioReal ) }`}
                    </Button>
                </Grid>
                )}
            </Grid>
        </form> 
    )
}
